import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const getLastCallServiceCompany = async (formattedPhoneNum) => {
  return request.get(
    `Phone/last_call_service_company?phone=${formattedPhoneNum}`,
    null,
    'При загрузке последнего звонка произошла ошибка'
  );
};

const useLastCallServiceCompany = () => {
  const mutation = useMutation(getLastCallServiceCompany);

  const handleGetLastCallServiceCompany = (formattedPhoneNum) =>
    mutation.mutateAsync(formattedPhoneNum);

  return {
    handleGetLastCallServiceCompany,
    ...mutation,
  };
};

export default useLastCallServiceCompany;
